import React from "react";
import { SectionContainerLight } from "../common/sections/SectionContainerLight";

export const educationPhases = [
  {
    id: "1.0",
    title: "Eksplorasi teknologi",
    subtitle: "Eksplorasi",
    img: "/img/ekskul/Gambar-1.0.png",
  },
  {
    id: "2.0",
    title: "Pengembangan keterampilan",
    subtitle: "Pelatihan",
    img: "/img/ekskul/Gambar-2.0.png",
  },
  {
    id: "3.0",
    title: "Penguatan Kompetensi",
    subtitle: "Pencapaian",
    img: "/img/ekskul/Gambar-3.0.png",
  },
  {
    id: "4.0",
    title: "Prestasi & portofolio",
    subtitle: null,
    img: "/img/ekskul/Gambar-4.0.png",
  },
];

const HeroSection = () => {
  return (
    <SectionContainerLight
      id="bootcamp_hero"
      additionalClassName="mx-6 !py-0 my-6"
    >
      <div className="relative mx-auto max-w-7xl px-4 md:px-8">
        <img
          src="/img/course/ornaments/cross.png"
          alt="cross"
          className="absolute hidden md:block lg:top-[120px] md:top-[100px] lg:right-[10px] md:right-[60px] w-[100px] z-0"
        />
        <img
          src="/img/course/ornaments/dots.png"
          alt="dots"
          className="absolute hidden md:block lg:top-[80px] lg:left-[680px]  md:top-[50px] md:left-[350px] w-[100px] z-0"
        />
        <img
          src="/img/course/ornaments/triangle.png"
          alt="triangle"
          className="absolute hidden md:block lg:bottom-[10px] lg:right-[480px] md:bottom-[-50px] md:right-[50px] w-[50px] z-0"
        />

        <div className="mr-2 hidden md:block absolute lg:right-6 md:top-[-20px] md:right-5 h-full w-[550px] pointer-events-none z-10">
          <img
            src="/img/ekskul/img-ekskul.png"
            alt="Hero Person"
            className="h-full w-full object-contain"
          />
        </div>

        <div className="flex flex-col lg:flex-row lg:items-start gap-10">
          <div className="w-full lg:w-1/2 lg:pr-12 mt-8 lg:mt-12">
            <p className="text-teal-600 font-body text-xl sm:text-2xl font-medium mb-2 leading-relaxed md:whitespace-nowrap">
              Ekstrakulikuler
            </p>
            <h1 className="text-2xl md:text-[40px] font-body font-bold text-gray-900 mb-2 md:mb-4 leading-normal">
              <span className="block">From Zero to Hero: A</span>
              <span className="whitespace-normal md:whitespace-nowrap">
                Beginner&apos;s Guide
              </span>
            </h1>
            <p className="font-body font-semibold text-base md:text-lg text-secondary-100 mb-4 md:whitespace-nowrap">
              Khusus jenjang sekolah SD, SMP, SMA <br /> Selama 6 bulan sampai
              12 bulan
            </p>
            <p className="text-secondary-100 text-justify text-base md:text-lg mb-8 max-w-lg leading-relaxed">
              Jelajahi dunia pemrograman dengan ekstrakulikuler kami! Mulai dari
              dasar hingga lanjutan, kami akan membantu Anda mengembangkan
              kemampuan keterampilan untuk masa depan.
            </p>

            <div className="hidden lg:block max-w-fit border-2 border-blue-600 rounded-xl p-4 mt-4 ml-0 mx-auto bg-white">
              <div className="hidden lg:flex flex-row items-start justify-center gap-x-2">
                {educationPhases.map((phase, index) => (
                  <div
                    className="flex flex-col items-center md:flex-row md:items-start"
                    key={phase.id}
                  >
                    <div className="flex flex-col items-center md:items-start">
                      <img
                        src={phase.img}
                        alt={phase.id}
                        width={48}
                        height={48}
                      />
                      <p className="font-bold text-blue-600 text-base md:text-sm mt-2">
                        {phase.id}
                      </p>
                      <p className="text-gray-800 text-base md:text-xs text-center md:text-start leading-tight">
                        {phase.title.includes(" ") ? (
                          <>
                            {phase.title.split(" ")[0]} <br />
                            {phase.title.split(" ").slice(1).join(" ")}
                          </>
                        ) : (
                          phase.title
                        )}
                      </p>
                    </div>
                    {/* Arrow dan Subtitle */}
                    {phase.subtitle && index < educationPhases.length - 1 && (
                      <div
                        className={`flex flex-col items-center justify-center mt-3 ${
                          index === 1 ? "-ml-2 mr-2" : "ml-4 mr-2"
                        }`}
                      >
                        <p className="text-xs md:text-[10px] font-bold text-gray-600 text-center leading-tight mb-1">
                          {phase.subtitle.split(" ").map((word, i) => (
                            <span key={i}>
                              {word}
                              <br />
                            </span>
                          ))}
                        </p>

                        <img
                          src="/img/ekskul/Arrow.png"
                          alt="arrow"
                          width={45}
                          height={35}
                        />
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>

            {/* Mobile */}
            <div className="max-w-fit border-2 border-blue-600 rounded-xl p-4 md:ml-0 md:mt-4 mx-auto bg-white grid grid-cols-2 gap-4 lg:hidden">
              {educationPhases.map((phase) => (
                <div className="flex flex-col items-center" key={phase.id}>
                  <img src={phase.img} alt={phase.id} width={48} height={48} />
                  <p className="font-bold text-blue-600 text-base mt-2">
                    {phase.id}
                  </p>
                  <p className="text-gray-800 text-base text-center leading-tight">
                    {phase.title.includes(" ") ? (
                      <>
                        {phase.title.split(" ")[0]} <br />
                        {phase.title.split(" ").slice(1).join(" ")}
                      </>
                    ) : (
                      phase.title
                    )}
                  </p>
                  {/* Subtitle below the title */}
                  {phase.subtitle && (
                    <p className="text-xs font-bold text-gray-600 text-center mt-2">
                      {phase.subtitle}
                    </p>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </SectionContainerLight>
  );
};

export default HeroSection;
